<template>
    <div class="flex">
        <h4>Auction Details</h4>
        <div class="top-controls-container">
            <div v-if="activeAuction" class="active-auction-details">
                <p>Active Auction: <b>{{ `(${activeAuction.id}) ${activeAuction.name} ` }}</b></p>
                <p>Start Time: <b>{{ activeAuction.start_date }}</b></p>
                <p>Live Auctioneers URL: <b>{{ activeAuction.live_auctioneers_url || 'n/a' }}</b></p>
                 <div class="textRight">
                    <button v-if="currentLiveInventoryId" class="button" @click="concludeAuction()">Conclude Auction</button>
                    <button v-else-if="auctionHasEnded" class="button" @click="shutdownAuction()">Shutdown Auction</button>
                </div>
            </div>
            <div v-else-if="nextAuction" class="active-auction-details">
                <p>Next Auction: <b>{{ parseEntities(`(${nextAuction.id}) ${nextAuction.name}`) }}</b></p>
                <p>Start Time: <b>{{ nextAuction.start_date }}</b></p>
                <p>Live Auctioneers URL: <b>{{ nextAuction.live_auctioneers_url || 'n/a' }}</b></p>
            </div>
            <div v-else class="active-auction-details">
                <p>No active auction</p>
            </div>
        </div>

        <AuctionShutdownModal v-if="activeAuction" v-bind:showShutdownModal="showAuctionShutdownModal" v-bind:closeShutdownModal="closeShutdownModal"
            v-bind:activeAuction="activeAuction">
        </AuctionShutdownModal>

        <LoadingOverlayComponent v-if="showLoading" v-bind:title="loadingTitle"></LoadingOverlayComponent>

        <!-- Conclude Auction Confirmation -->
        <AlertConfirmComponent v-if="showConcludeConfirmAlert" v-bind:title="confirmConcludeAlertTitle"
            v-bind:message="confirmConcludeAlertMessage" v-bind:submitText="confirmConcludeAlertSubmitText"
            v-bind:cancelText="confirmConcludeAlertCancelText" @submit="submitConcludeConfirm()"
            @close="closeConcludeConfirm()">
        </AlertConfirmComponent>

        <!-- Shutdown Auction Confirmation -->
        <AlertConfirmComponent v-if="showShutdownConfirmAlert" v-bind:title="confirmShutdownAlertTitle"
            v-bind:message="confirmShutdownAlertMessage" v-bind:submitText="confirmShutdownAlertSubmitText"
            v-bind:cancelText="confirmShutdownAlertCancelText" @submit="submitShutdownAuction()"
            @close="closeShutdownConfirm()">
        </AlertConfirmComponent>

        <!-- Generic Alert -->
        <AlertComponent v-if="showAlert" v-bind:title="alertTitle"
            v-bind:message="alertMessage" v-bind:secondaryAction=null @close="closeAlert()">
        </AlertComponent>
    </div>
</template>

<script>

import apiMixin from '@/mixins/apiMixin.js'
import LoadingOverlayComponent from '@/components/Shared/LoadingOverlayComponent.vue'
import AlertComponent from '@/components/Shared/AlertComponent.vue'
import AlertConfirmComponent from '@/components/Shared/AlertConfirmComponent.vue'
import AuctionShutdownModal from './AuctionShutdownModal.vue'

export default {
    name: 'AuctionDetailsCard',
    components: {
        LoadingOverlayComponent,
        AlertComponent,
        AlertConfirmComponent,
        AuctionShutdownModal,
    },
    mixins: [apiMixin],
    props: ['activeAuction', 'nextAuction', 'getActiveAuction'],
    data() {
        return {
            showLoading: false,
            loadingTitle: 'Loading...',
            // Alerts
            showAlert: false,
            alertTitle: '',
            alertMessage: '',
            // Alert Conclude auction Confirm
            showConcludeConfirmAlert: false,
            confirmConcludeAlertTitle: 'Conclude Auction?',
            confirmConcludeAlertMessage: `Concluding the auction will perform the following actions:
            <ul>
                <li>End the virtual auctioneer and third-party scripts</li>
                <li>Clear the banner</li>
                <li>Broadcast "Auction Concluded" message</li>
            </ul>`,
            confirmConcludeAlertSubmitText: 'Confirm',
            confirmConcludeAlertCancelText: 'Cancel',
            // Alert Shutdown auction Confirm
            showShutdownConfirmAlert: false,
            confirmShutdownAlertTitle: 'Shutdown Auction?',
            confirmShutdownAlertMessage: `Shutting down the auction will perform the following actions:
            <ul>
                <li>Start the Auction Shutdown worker</li>
            </ul>`,
            confirmShutdownAlertSubmitText: 'Confirm',
            confirmShutdownAlertCancelText: 'Cancel',
            // Auction shutdown modal
            showAuctionShutdownModal: false,
        }
    },
    computed: {
        auctionHasEnded: function () {
            return this.activeAuction && this.activeAuction.concluded === true;
        },
        currentLiveInventoryId: function () {
            return this.$store.getters.currentLiveInventoryId
        },
        item: function () {
            if (this.$store.getters.item(this.currentLiveInventoryId) === null) {
                return {
                    inventory_id: 0,
                    lead_image: '',
                    display_lotnumber: '',
                    lead: ''
                }
            }
            return this.$store.getters.item(this.currentLiveInventoryId)
        },
    },
    mounted() {},
    methods: {

        /**
         * Close the alert
         */
        closeAlert() {
            this.showAlert = false
            if (this.shouldCloseModalAndNotExit === false) {
                this.exit()
            }
        },

        /**
         * Show the conclude auction confirm alert
         */
        concludeAuction() {
            this.showConcludeConfirmAlert = true;
        },

        /**
         * Close the conclude confirm alert
         */
        closeConcludeConfirm() {
            this.showConcludeConfirmAlert = false
        },

        /**
         * Show the shutdown auction confirm alert
         */
        shutdownAuction() {
            this.showShutdownConfirmAlert = true;
        },

        /**
         * Close the shutdown confirm alert
         */
        closeShutdownConfirm() {
            this.showShutdownConfirmAlert = false
        },

        /**
         * Close the shutdown modal
         */
        closeShutdownModal() {
            this.showAuctionShutdownModal = false
            this.getActiveAuction()
        },

        /**
         * Parse entities
         * @param {string} text 
         * @returns 
         */
        parseEntities(text) {
            const parser = new DOMParser();
            const parsed = parser.parseFromString(text, 'text/html');
            return parsed.body.textContent;
        },

        /**
         * Shutdown the auction
         */
        submitShutdownAuction() {
            this.showShutdownConfirmAlert = false
            if (!this.activeAuction) {
                this.alertTitle = 'Error'
                this.alertMessage = 'No active auction to shutdown'
                this.showAlert = true
                return;
            }
            this.showAuctionShutdownModal = true
        },

        /**
         * Submit the conclude auction confirm
         */
        submitConcludeConfirm() {
            this.showConcludeConfirmAlert = false

            if (this.thirdPartyRunning) {
                this.$root.$emit('end-third-party', false);
            }

            // End the auction script 
            var cmp = this
            let apiPayload = {}
            apiPayload.apiEndpoint = 'active_auction'
            apiPayload.postData = {}
            apiPayload.postData.action = 'end_auction'
            apiPayload.postData.auction_id = this.activeAuction?.id;
            apiPayload.postData.inventory_id = this.item.inventory_id;
            apiPayload.postData.conclude = true

            this.loadingTitle = 'Concluding auction'
            this.showLoading = true
            cmp.$store.dispatch('apiCall', apiPayload).then(response => {
                this.showLoading = false
                if (response.data.result !== 'success') {
                    this.alertTitle = 'Error'
                    this.alertMessage = response.data.message
                    this.showAlert = true
                } else {
                    this.alertTitle = 'Success'
                    this.alertMessage = 'Auction Ended!'
                    this.showAlert = true
                }
            })
        },
    },
}
</script>

<style scoped>
.active-auction-details {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    width: 100%;
}

.active-auction-details p {
    margin: 0;
    margin-bottom: 8px;
}
.flex {
    display: flex;
    flex-direction: column;
}
.top-controls-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    border-radius: 4px;
    padding: 1rem;
}
.button {
    background-color: #007AFF;
    color: white;
    border: 1px solid #007AFF;
    border-radius: 4px;
}
</style>